import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "auth flex flex-align-center full-height" }
const _hoisted_2 = { class: "auth__field" }
const _hoisted_3 = { class: "auth__label" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "auth__error"
}
const _hoisted_6 = { class: "auth__field" }
const _hoisted_7 = { class: "auth__label" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = { class: "flex flex-justify-between" }
const _hoisted_10 = { class: "requirements mr-2" }
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      class: "full-width",
      onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.confirmPassword && _ctx.confirmPassword(...args)), ["prevent"]))
    }, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('CREATE_PASSWORD.CREATE_PASSWORD')), 1),
      _createElementVNode("label", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('COMMON.PASSWORD')), 1),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["auth__input", { "is-invalid": _ctx.showNewPasswordError }]),
          type: "password",
          onKeyup: _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_ctx.confirmPassword && _ctx.confirmPassword(...args)), ["enter"])),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.request.newPassword) = $event)),
          placeholder: _ctx.$t("COMMON.PASSWORD")
        }, null, 42, _hoisted_4), [
          [_vModelText, _ctx.request.newPassword]
        ]),
        (_ctx.errorMessage("NewPassword"))
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.errorMessage("NewPassword")), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("label", _hoisted_6, [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('CREATE_PASSWORD.REPEAT_PASSWORD')), 1),
        _withDirectives(_createElementVNode("input", {
          class: _normalizeClass(["auth__input", { "is-invalid": _ctx.showRepeatPasswordError }]),
          type: "password",
          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.confirmPassword && _ctx.confirmPassword(...args)), ["enter"])),
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.request.repeatPassword) = $event)),
          placeholder: _ctx.$t("CREATE_PASSWORD.REPEAT_PASSWORD")
        }, null, 42, _hoisted_8), [
          [_vModelText, _ctx.request.repeatPassword]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errorMessages(["RepeatPassword", "Email", "Token"]), (message) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "auth__error",
            key: message
          }, _toDisplayString(message), 1))
        }), 128))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.passwordRequirements, (requirement) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["requirement flex", _ctx.validationTouched ? requirement.valid ? "green--text" : "error--text" : ""])
            }, [
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "circle mr-05" }, null, -1)),
              _createTextVNode(_toDisplayString(_ctx.$t(requirement.text)), 1)
            ], 2))
          }), 256))
        ]),
        _createElementVNode("button", {
          class: _normalizeClass(["auth__submit", { "is-loading": _ctx.isLoading }]),
          type: "submit",
          disabled: _ctx.isLoading
        }, _toDisplayString(_ctx.$t('CREATE_PASSWORD.CREATE')), 11, _hoisted_11)
      ])
    ], 32)
  ]))
}